import styled from 'styled-components';
import { Flex } from '../Flex';
import { IconLoader } from '../Loader';

export const StyledIconLoader = styled(IconLoader).attrs({
  width: 16,
  height: 16,
})`
  width: 16px;
  height: 16px;
  min-width: 16px;
  min-height: 16px;
  margin-right: 4px;
  margin-top: 2px;
`;

export const FlagWrapper = styled(Flex)`
  width: 18px;
  height: 12px;
  margin: 4px 25px 0 0;
  padding: 0;
  box-shadow:
    0px 1px 1px -1px rgb(0 0 0 / 12%),
    0px 1px 1px 0px rgb(0 0 0 / 12%),
    0px 1px 3px 0px rgb(0 0 0 / 12%);
`;

export const IconWrapper = styled(Flex)`
  width: 12px;
  height: 12px;
  margin-right: 32px;
  padding-top: 3px;
  .MuiSvgIcon-root {
    width: 14px !important;
    height: 14px !important;
  }
`;

export const TextWrapper = styled(Flex)`
  white-space: nowrap;
`;

export const Header = styled.div`
  margin: 0 24px;
  padding: 3px 5px 8px 0;
  color: var(--search-text-color);
  font-size: 15px;
  font-weight: 500;
  border-bottom: 1px solid rgba(0, 0, 0, 20%);
  margin-bottom: 5px;
`;

export const KeyValueWrapper = styled.div`
  width: 100%;
  margin-bottom: 23px;
`;

export const KeyValueSearchResults = styled.div`
  width: 100%;
  overflow: auto;
`;

export const TickerCompanySearchResult = styled(Flex)`
  cursor: pointer;
  font-size: 14px;
  color: var(--search-text-color);
  margin: 0;
  padding: 4px 10px 4px 5px;
`;

export const TickerCompanySearchResultLableWrapper = styled.div<{ $hasText: number }>`
  font-weight: 500;
  width: ${({ $hasText }) => ($hasText ? '190px' : '700px')};
  max-width: ${({ $hasText }) => ($hasText ? '190px' : '700px')};
  overflow: hidden;
`;

export const TickerCompanySearchResultLabel = styled.div<{ $hasText: number }>`
  width: 100%;
  max-width: ${({ $hasText }) => ($hasText ? '190px' : '700px')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TickerCompanySearchResultTextWrapper = styled.div<{ $hasText: number }>`
  font-weight: 500;
  width: ${({ $hasText }) => ($hasText ? '480px' : '0px')};
  max-width: ${({ $hasText }) => ($hasText ? '480px' : '0px')};
  padding-left: 6px;
`;

export const TickerCompanySearchResultText = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DashboardWrapper = styled.div`
  width: 100%;
  margin-bottom: 23px;
`;

export const DashboardSearchResults = styled.div`
  width: 100%;
  overflow: auto;
`;

export const DashboardSearchResult = styled(Flex)`
  cursor: pointer;
  font-size: 14px;
  color: var(--search-text-color);
  margin: 0;
  padding: 4px 10px 4px 5px;
`;

export const MoreButtonContainer = styled.div`
  float: right;
  padding: 12px 24px 0 0;
`;

export const MoreButton = styled.button`
  cursor: pointer;
  color: var(--search-text-color);
  background: var(--page-background);
  border: 1px solid var(--page-background);
  font-size: 14px;
  margin: 0 0 5px 24px;
`;
